import { Col, Image, Row } from "react-bootstrap";
import Questionnaire from "./interviewQuestions.js";
import Skills from "../skills.js";

import interviewLoadingImg from "../../../assets/images/resume/interview-loading.svg";
import { useState, useEffect } from "react";
import ToggleButtonCustom from "../../../components/templates/toggleBtn.js";
import { getInterviewQuestions } from "../helper.js";

const Interview = ({ isInsightsVisible, resumeId }) => {
  const [questions, setQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    let isMounted = true;
    const fetchQuestions = async () => {
      if (!resumeId) return;
      console.log(resumeId);

      try {
        setIsLoading(true);
        const details = await getInterviewQuestions(resumeId);
        console.log("det", details);

        if (isMounted && Object.values(details).length > 0) {
          setQuestions(details);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching resume details:", error);
      }
    };

    fetchQuestions();

    return () => {
      isMounted = false;
    };
  }, [resumeId]);
  return (
    <div className="interview-questions mb-4">
      <Row>
        <Col xl={isInsightsVisible ? 12 : 8} lg={6}>
          {isLoading ? (
            <div className="interview-loading">
              <div className="content">
                <h3 className="heading-3">
                  We are Getting Interview Questions{" "}
                </h3>
                <p className="pargraph">
                  Lörem ipsum protism soködade att pseudoligen semick, transcism
                  heteromatisk och heteroska Lörem ipsum protism soködade att
                  pseudoligen semick, transcism heteromatisk och heteroska
                </p>
                <Image src={interviewLoadingImg} className="shimmer" />
              </div>
            </div>
          ) : (
            <Questionnaire
              questionsData={questions?.final_questions_dict?.questions}
            />
          )}
        </Col>
        <Col xl={4} lg={5} className={isInsightsVisible && "d-none"}>
          <Skills isLoading={isLoading} skillsData={questions?.metadata} />
        </Col>
      </Row>
    </div>
  );
};

export default Interview;
